export const scheduleTypeList = [
  { id: "regular", name: "Regular" },
  { id: "cca", name: "CCA" },
  { id: "both", name: "Both" },
];
